import { HiMail } from "react-icons/hi";

import { FaLinkedinIn, FaTwitter, FaWhatsapp } from "react-icons/fa";
import { BsGithub } from "react-icons/bs";

export default function Contact() {
  return (
    <section
      id="contact-me"
      className="py-20 lg:py-40 border-y border-[#DFDFDF] text-center min-h-screen grid place-items-center"
    >
      <div className="sm:container mx-auto">
        <h1 className="md:text-xl">Tell me about your next project.</h1>

        <p className="md:text-xl">
          Let's do it together, my inbox is always open.
        </p>

        <a
          className="flex items-center justify-center uppercase py-2 px-4 mt-10 mb-4 border bg-[#f34c08] border-[#f34c08] rounded-xl w-[60%] md:w-[20%] mx-auto md:text-xl"
          href="mailto:ejembijoshman@gmail.com"
          title="ejembijoshman@gmail.com"
        >
          Get in touch <HiMail className="ml-2 text-white animate-bounce" />
        </a>

        <ul
          style={{ marginTop: 20 }}
          className="space-x-5 flex items-center justify-center"
        >
          <li className="">
            <a
              href="https://wa.link/uws0lz"
              target="_blank"
              rel="noopener noreferrer"
              title="Whatsapp link icon"
              alt="Whatsapp icon"
              className="text-white text-2xl"
            >
              <FaWhatsapp />
            </a>
          </li>
          <li className="">
            <a
              href=" https://www.linkedin.com/in/blaq-dev"
              target="_blank"
              rel="noopener noreferrer"
              title="Linkedin icon link"
              alt="linkedin icon"
              className="text-white text-2xl"
            >
              <FaLinkedinIn />
            </a>
          </li>
          <li className="">
            <a
              href="https://twitter.com/blaqdev"
              target="_blank"
              rel="noopener noreferrer"
              title="Twitter link Icon"
              alt="twitter icon"
              className="text-white text-2xl"
            >
              <FaTwitter />
            </a>
          </li>
          <li className="">
            <a
              href="https://github.com/106joshman"
              target="_blank"
              rel="noopener noreferrer"
              title="Github link Icon"
              alt="github icon"
              className="text-white text-2xl"
            >
              <BsGithub />
            </a>
          </li>
        </ul>
      </div>
    </section>
  );
}
